import { Value } from '@philips-internal/oswald-ui-core';

export interface ManifestDependency {
  name: string;
  version: string;
}

export interface ManifestJson {
  LOT?: string;
  REF?: string;
  UDI?: string;
  date?: string;
  dependencies?: ManifestDependency[];
  version: string;
}

export enum brazilLabelEnum {
  brazilLabel                 = 'label.about-box.brazil-label',
  productLabel                = 'label.about-box.product',
  productVersion              = 'tws.login.version',
  productText                 = 'tws.about-box.version',
  technicalNameLabel          = 'label.about-box.technical-name',
  technicalNameText           = 'text.about-box.software',
  productUseInstructionsLabel = 'label.about-box.product-use-instructions',
  productUseInstructionsText  = 'text.about-box.use-instructions',
  manufacturerLabel           = 'label.about-box.manufacturer',
  manufacturerText            = 'tws.about-box.company-address',
  registrationHolderLabel     = 'label.about-box.registration-holder',
  registrationHolderText      = 'text.about-box.registration-holder-address',
  technicalManagerLabel       = 'label.about-box.technical-manager',
  technicalManagerText        = 'text.about-box.technical-manager-name',
  serialNumberBatchLabel      = 'label.about-box.serial-number-batch',
  manufacturingDateLabel      = 'label.about-box.manufacturing-date',
  anvisaNotificationLabel     = 'label.about-box.anvisa-notification',
  anvisaNotificationText      = 'text.about-box.anvisa-notification-number',
  manifestJson                = '/manifest.json',
  unspecifiedText             = 'tws.about-box.unspecified'
}

export const MANIFEST    = brazilLabelEnum.manifestJson;
export const UNSPECIFIED = brazilLabelEnum.unspecifiedText;

export const BRAZIL_LABEL_DATA = {
  data: [
    {
      label: brazilLabelEnum.productLabel,
      value: ''
    },
    {
      label: brazilLabelEnum.technicalNameLabel,
      value: brazilLabelEnum.technicalNameText
    },
    {
      label: brazilLabelEnum.productUseInstructionsLabel,
      value: brazilLabelEnum.productUseInstructionsText
    },
    {
      label: brazilLabelEnum.manufacturerLabel,
      value: brazilLabelEnum.manufacturerText
    },
    {
      label: brazilLabelEnum.registrationHolderLabel,
      value: brazilLabelEnum.registrationHolderText
    },
    {
      label: brazilLabelEnum.technicalManagerLabel,
      value: brazilLabelEnum.technicalManagerText
    },
    {
      label: brazilLabelEnum.serialNumberBatchLabel,
      value: ''
    },
    {
      label: brazilLabelEnum.manufacturingDateLabel,
      value: ''
    },
    {
      label: brazilLabelEnum.anvisaNotificationLabel,
      value: brazilLabelEnum.anvisaNotificationText
    }
  ],
  label: brazilLabelEnum.brazilLabel
}

export type Response = {
  body: Record<string, Value>;
  bodyUsed: boolean;
  headers: Record<string, Value>;
  ok: boolean;
  redirected: boolean;
  status: number;
  statusText: string;
  type: string;
  url: string;
}
